import React from "react";
import styled, { keyframes } from "styled-components";
import { compose, lifecycle, withState } from "recompose";
import { ModalTitle, ModalSubtitle } from "../common/Modal";
import { Cta } from "../common/Button";
import Preview, { PREVIEW_HEIGHT, PREVIEW_WIDTH } from "../common/Preview";

const Rendering = props => {
  const { onCancelRendering, getCurrentComposition } = props;
  const composition = getCurrentComposition();
  return (
    <RenderingLayout>
      <RenderingTitle>We're processing your video</RenderingTitle>
      <RenderingSubtitle>
        This could take a few minutes. We will email you when it's ready so you don't have to wait.
      </RenderingSubtitle>
      <PreviewContainer>
        <PreviewLoader composition={composition} />
      </PreviewContainer>
      {/* <Footnote>Don't worry, you'll receive your video by email as soon as it's ready.</Footnote> */}
      <ButtonContainer>
        <Cta onClick={onCancelRendering}>Cancel</Cta>
      </ButtonContainer>
    </RenderingLayout>
  );
};

const RenderingLayout = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 45px 25px 0px;
`;

const RenderingTitle = styled(ModalTitle)`
  margin: auto;
`;

const RenderingSubtitle = styled(ModalSubtitle)`
  margin-bottom: 24px;
`;

const ButtonContainer = styled.div`
  width: 80%;
`;

const LOADING_DURATION = 2 * 60;

const PreviewLoader = ({ composition }) => (
  <PreviewLoaderLayout>
    <LoadingOverlay />
    <Preview onReady={() => console.log("Preview loader ready")} composition={composition} />
  </PreviewLoaderLayout>
);

const loadingKeyframes = keyframes`
  0% {
    width:100%;
  }
  100% {
    width:5%;
  }
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(99, 218, 154, 0.5);
  animation: ${loadingKeyframes} ${LOADING_DURATION}s cubic-bezier(0.39, 1.05, 0.61, 0.66);
`;

const PreviewLoaderLayout = styled.div`
  position: relative;
  height: ${PREVIEW_HEIGHT}px;
  width: ${PREVIEW_WIDTH}px;
`;

const PreviewContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const enhancer = compose(
  lifecycle({
    componentDidMount() {
      if (window.gtag) {
        window.gtag("event", "page_view", { title: "Video Rendering" });
      }
    },
  })
);

export default enhancer(Rendering);
